<!-- /////////////////////////////////////////////////////////////////////////// TEMPLATE -->

<template>

    <div class="flex p-4 bg-gray-50">

        <!-- first column -->
        <div class="w-1/3 mr-2">
            <order-return-conditions-card :order="row.order" class="mb-4" />
            <return-questionnaire-answers-card :o-return="row" class="mb-4" />
        </div>

        <!-- second column -->
        <div class="w-1/3 mx-2">

        </div>

        <!-- third column -->
        <div class="w-1/3 ml-2">
            <return-price-card v-can="'price:view'" :o-return="row" class="mb-4" />
            <lens-price-card v-can="'price:view'" :order="row.order" class="mb-4" />
            <return-actions-card v-can="'return:delete'" :o-return="row" @remove="$emit('remove', $event)" />
        </div>

    </div>
</template>

<!-- /////////////////////////////////////////////////////////////////////////// SCRIPT -->

<script>

import OrderReturnConditionsCard from '@/components/cards/OrderReturnConditionsCard.vue';
import ReturnQuestionnaireAnswersCard from '@/components/cards/ReturnQuestionnaireAnswersCard.vue';
import ReturnPriceCard from '@/components/cards/ReturnPriceCard.vue';
import ReturnActionsCard from '@/components/cards/ReturnActionsCard.vue';
import LensPriceCard from '@/components/cards/LensPriceCard.vue';

export default
{
    name: 'LensReturnTableDetails',

    components:
    {
        OrderReturnConditionsCard,
        ReturnQuestionnaireAnswersCard,
        ReturnPriceCard,
        ReturnActionsCard,
        LensPriceCard,
    },

    props:
    {
        row:
        {
            type:     Object,
            required: true,
        },

        updating:
        {
            type:    Boolean,
            default: false,
        },
    },

    emits: ['remove'],
};

</script>

<!-- /////////////////////////////////////////////////////////////////////////// STYLE -->

<style lang="scss" scoped>



</style>
